@if (operation) {
<tec-collapse [title]="`WORKFLOWS.FORM.OPERATIONS.DOCUMENTS` | translate" [badge]="index.toString()">
    <app-developer-curl-button
        ngProjectAs="tec-button-icon"
        [path]="operationCurlPath()"
        titleKey="WORKFLOWS.CURL_MODAL.TITLE_OPERATION"
    />
    <tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.DOCUMENTS_SECTION_TITLE' | translate"
        [subtitle]="'WORKFLOWS.DETAIL.DOCS_DESCRIPTION' | translate">

        @if (operation?.config?.docs?.length > 0) {
            @for (doc of operation?.config?.docs; track $index) {
            <tec-item
                [tagImage]="{ icon: getDocumentIcon(doc?.type), status: 'control' }"
                [title]="resolveDocTitle(doc)">
                @if (doc?.required) {
                <tec-tag [label]="'WORKFLOWS.FORM.OPERATIONS.MANDATORY' | translate | uppercase" [status]="'warning'" />
                }

                <tec-link [label]="'GENERAL.SHOW_DETAILS' | translate" (click)="seeDetails(doc)" />
            </tec-item>
            }
        }
    </tec-tile>

    <tec-tile [title]="'WORKFLOWS.FORM.CONF_ADVANCED' | translate">
        <tec-info-group
            [label]="'WORKFLOWS.FORM.OPERATIONS.TUTORIAL' | translate"
            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.TUTORIAL_DESCRIPTION' | translate"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${operation?.config?.tutorial ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="operation?.config?.tutorial ? 'success' : 'disabled'"
            />
        </tec-info-group>
    </tec-tile>
</tec-collapse>

@if (showModalDocDetails) {
<app-modal-doc-details [doc]="selectedDoc" (closeEvent)="closeModal()" />
}
}
